export default __webpack_public_path__ + "bcbff731807b8842e2bde4781924d6ef.svg";